import {useMemo} from 'react';

import {ItemType, useCharacterCatalogQuery} from '../../../../generated/types';
import {createCatalog} from './create-catalog';

const CATALOG_ITEM_TYPES = [ItemType.Weapon, ItemType.Armor, ItemType.ArtisansTools, ItemType.Tool, ItemType.GamingSet];

export function useCatalog() {
	const {data, loading, error} = useCharacterCatalogQuery({ssr: false, variables: {itemTypes: CATALOG_ITEM_TYPES}});
	const catalog = useMemo(() => (data ? createCatalog(data) : undefined), [data]);
	return {catalog, loading, error};
}
